export const containerStyle = {
    display: "flex" ,
    flexDirection : "column" ,
    justifyContent : "center",
    alignItems :   "center",
    backgroundColor : "white",
    width : "100%",
    minHight : "400PX",
    marginTop : "100px"
    

};

export const logStyle = {
    
    marginTop : "20px"
};